export default __webpack_public_path__ + "static/media/arrow-down.da6b3bb2.svg";